module.exports = __webpack_public_path__ + "img/email.9220520a.svg";